import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string } from 'prop-types';
import { Container, Iframe } from './styled';
import { embedYoutubeUrl } from '../../utils';

const Embed = _ref => {
  let {
    src,
    ratio
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["src", "ratio"]);

  const [width, height] = (ratio && typeof ratio === 'string' ? ratio : '16:9').split(':');
  const aspecRatio = width && height ? height / width : null;
  const padding = aspecRatio && !Number.isNaN(aspecRatio) ? (aspecRatio * 100).toFixed(2) : '56.25';
  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": "embed",
    padding: padding
  }, props), /*#__PURE__*/React.createElement(Iframe, {
    src: embedYoutubeUrl(src)
  }));
};

process.env.NODE_ENV !== "production" ? Embed.propTypes = {
  src: string.isRequired,
  ratio: string
} : void 0;
Embed.defaultProps = {
  ratio: '16:9'
};
export default Embed;